<form #depForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/department']">Department</a> > {{ department.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(depForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Name</mat-label>
            <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="department.name" required>
            <mat-error *ngIf="name.invalid && name.touched">Required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-3">
        <div class="example-container col-sm-6">
          <h4>Processes</h4>
          <div [ngClass]="{'disableOnClick':isFormDisabled}" cdkDropList #todoList="cdkDropList" [cdkDropListData]="todo" [cdkDropListConnectedTo]="[doneList]" class="example-list" (cdkDropListDropped)="drop($event)">
            <div class="example-box" *ngFor="let item of todo" cdkDrag>{{ item['name'] }}</div>
          </div>
        </div>
        <div class="example-container col-sm-6">
          <h4>Mapped Processes</h4>
          <div [ngClass]="{'disableOnClick':isFormDisabled}" cdkDropList #doneList="cdkDropList" [cdkDropListData]="done" [cdkDropListConnectedTo]="[todoList]" class="example-list" (cdkDropListDropped)="drop($event)">
            <div class="example-box" *ngFor="let item of done" cdkDrag>{{ item['name'] }}</div>
          </div>
        </div>
      </div>

      <div cdkDropList #listOne="cdkDropList" [cdkDropListConnectedTo]="[listTwo]"></div>
      <div cdkDropList #listTwo="cdkDropList" [cdkDropListConnectedTo]="[listOne]"></div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="department" [recordId]="department.id"></app-audit-log-viewer>
</form>
